import { inject } from '@angular/core';

import { PlanSyncStore } from './plan-sync.store';

/** Does not wait for HTTP: a pending transfer or the account fetch must not delay bootstrap. */
export const initializePlanSync = (): void => {
  inject(PlanSyncStore).init();
};
